import template from './access-roles.html'
import './access-roles.css';

/**
 * Page to edit access roles (groups)
 */
class AccessRolesVM
{
	constructor (dialog, page)
	{
		this.dialog = dialog;
		this.page = page;

		this.groups = ko.observableArray([]);

		this.roles = ko.observableArray([]);
		this.role_categories = ko.observableArray([]);

		this.show_new_group = ko.observable(false);
		this.new_group_name = ko.observable('');

		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(20);
		this.page_count = ko.observable(1);
		this.sort_field = ko.observable('role_name');
		this.sort_order = ko.observable('ASC');

	}

	async btnRemoveRoleFromGroup_click(group, role)
	{
		group.direct_membership.splice(group.direct_membership().indexOf(role.role_name), 1);
		const result = await Application.fetches.postJSON('/api/access-role', {role_name: group.role_name, direct_membership: group.direct_membership()});
		if (result.status != 'OK')
		{
			Application.alerts.alert({type: 'error', message: result.message});
			return;
		}

		let membership = group.membership();
		membership = membership.filter((m) => !role.membership.includes(m));
		group.membership(membership);
	}

	async btnAddRoleToGroup_click(group, role)
	{
		group.direct_membership.push(role.role_name);
		const result = await Application.fetches.postJSON('/api/access-role', {role_name: group.role_name, direct_membership: group.direct_membership()});
		if (result.status != 'OK')
		{
			Application.alerts.alert({type: 'error', message: result.message});
			return;
		}

		let membership = group.membership();
		membership = membership.concat(role.membership);
		group.membership(membership);
	}

	async btnNewGroup_click()
	{
		let display_name = this.new_group_name().trim();
		display_name = display_name.replace(/\s+/g, ' ');
		if (!/^[a-zA-Z0-9_-\s]*$/.test(display_name))
		{
			Application.alerts.alert({type: 'warning', title: 'Invalid group name', message: 'Group names may not contain special characters' });
			return;
		}

		let role_name = display_name.toLowerCase().replace(/\s+/g, '_');

		if (!(await Application.alerts.confirm({type: 'warning', title: 'Confirm', message: 'Are you sure you want to create this group?'})))
			return;
		
		const result = await Application.fetches.postJSON('/api/access-role', {role_name: role_name, display_name: display_name, role_type: 'GROUP'});
		if (result.status != 'OK')
		{
			Application.alerts.alert({type: 'warning', title: 'Error', message: result.message});
			return;
		}

		let group = {
			role_name: role_name,
			display_name: display_name,
			membership: ko.observableArray([]),
			direct_membership: ko.observableArray([])
		};
		let group_roles = {};
		for (let role of this.roles())
		{
			group_roles[role.role_name] = {
				checked: ko.pureComputed(() => { if (group.membership().includes(role.role_name)) return true; }),
				direct: ko.pureComputed(() => { if (group.direct_membership().includes(role.role_name)) return true; })
			}
		}
		group.group_roles = group_roles;
		this.groups.push(group);
		

		this.show_new_group(false);
		this.new_group_name('');

	}

	back_to_top ()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	a_edit_click (row)
	{
		this.page.edit_dialog(row);
	}

	btn_add_click()
	{
		this.dialog.edit_dialog(null);
	}

}

class AccessRolesPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AccessRolesVM(this, this);
		this.access_roles = [];

		let visible_columns = localStorage.getItem('ps_dashboard.access_roles.visible_columns');
		if (visible_columns)
			this.viewModel.visible_columns(JSON.parse(visible_columns));
	}

	async init ()
	{
		let data = await Grape.cache.fetch('AccessRoles');
		let _groups = [];
		let _roles = [];
		let _role_categories = {};
		for (let role of data) {
			if (role.role_type == 'GROUP')
			{
				_groups.push(role);
			}
			else
			{
				_roles.push(role);
				if (!_role_categories.hasOwnProperty(role.category))
					_role_categories[role.category] = [];
				_role_categories[role.category].push(role);
			}
		}

		let groups = [];
		for (let g of _groups)
		{
			let group = {
				role_name: g.role_name,
				display_name: g.display_name,
				membership: ko.observableArray(g.membership),
				direct_membership: ko.observableArray(g.direct_membership)
			};
			let group_roles = {};
			for (let role of _roles)
			{
				group_roles[role.role_name] = {
					checked: ko.pureComputed(() => { if (group.membership().includes(role.role_name)) return true; }),
					direct: ko.pureComputed(() => { if (group.direct_membership().includes(role.role_name)) return true; })
				}
			}
			group.group_roles = group_roles;
			groups.push(group);
		}
		groups = groups.sort((a,b) => a.role_name > b.role_name);
		this.viewModel.groups(groups);
		this.viewModel.roles(_roles);
		let rcs = [];
		for (let rc of Object.keys(_role_categories))
			rcs.push({category: rc, roles: _role_categories[rc]});
		this.viewModel.role_categories(rcs);
	}

	async updateData ()
	{
	}

	async edit_dialog (row)
	{
		let name_editable = false;
		if (!row)
		{
			var row = {role_name: '', membership: [], assigned_roles: []};
			name_editable = true;
		}

		if (!row.assigned_roles)
			row.assigned_roles = [];

	}
}

//Assign Page(HTML/JS) to Grape
export default {
	route: '[/]ui/admin/access-roles',
	page_class: AccessRolesPage,
	template: template
}
